module.exports = __webpack_public_path__ + "img/user.fcd52cb8.svg";